import "./InfoCardSkeleton.scss";

export const InfoCardSkeleton = () => {
  return (
    <div className="data-banner-skeleton pulse">
      <div className="data-banner-skeleton-content">
        {/*<div className="data-banner-skeleton-text pulse"></div>*/}
        {/*<div className="data-banner-skeleton-link pulse"></div>*/}
      </div>
    </div>
  );
};
